// ============================================================
// MUI Typography Configuration
// ============================================================

import { tokens } from './tokens';

export const typography = {
  fontFamily: tokens.typography.fontFamily,
  fontWeightRegular: tokens.typography.fontWeights.regular,
  fontWeightMedium: tokens.typography.fontWeights.medium,
  fontWeightBold: tokens.typography.fontWeights.bold,

  h1: {
    fontSize: tokens.typography.sizes['4xl'],
    fontWeight: tokens.typography.fontWeights.bold,
    lineHeight: 1.2,
    letterSpacing: '-0.025em',
  },
  h2: {
    fontSize: tokens.typography.sizes['3xl'],
    fontWeight: tokens.typography.fontWeights.bold,
    lineHeight: 1.3,
    letterSpacing: '-0.02em',
  },
  h3: {
    fontSize: tokens.typography.sizes['2xl'],
    fontWeight: tokens.typography.fontWeights.semiBold,
    lineHeight: 1.3,
  },
  h4: {
    fontSize: tokens.typography.sizes.xl,
    fontWeight: tokens.typography.fontWeights.semiBold,
    lineHeight: 1.4,
  },
  h5: {
    fontSize: tokens.typography.sizes.lg,
    fontWeight: tokens.typography.fontWeights.semiBold,
    lineHeight: 1.4,
  },
  h6: {
    fontSize: tokens.typography.sizes.md,
    fontWeight: tokens.typography.fontWeights.semiBold,
    lineHeight: 1.5,
  },
  subtitle1: {
    fontSize: tokens.typography.sizes.md,
    fontWeight: tokens.typography.fontWeights.medium,
    lineHeight: 1.5,
  },
  subtitle2: {
    fontSize: tokens.typography.sizes.body,
    fontWeight: tokens.typography.fontWeights.medium,
    lineHeight: 1.5,
  },
  body1: {
    fontSize: tokens.typography.sizes.body,
    fontWeight: tokens.typography.fontWeights.regular,
    lineHeight: 1.6,
  },
  body2: {
    fontSize: tokens.typography.sizes.sm,
    fontWeight: tokens.typography.fontWeights.regular,
    lineHeight: 1.6,
  },
  caption: {
    fontSize: tokens.typography.sizes.xs,
    fontWeight: tokens.typography.fontWeights.regular,
    lineHeight: 1.5,
    color: tokens.colors.text.muted,
  },
  overline: {
    fontSize: tokens.typography.sizes.xs,
    fontWeight: tokens.typography.fontWeights.semiBold,
    lineHeight: 1.5,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
  button: {
    fontSize: tokens.typography.sizes.body,
    fontWeight: tokens.typography.fontWeights.semiBold,
    textTransform: 'none',
    letterSpacing: '0.01em',
  },
};
